{
  "close": "Stäng",
  "notifications": "{count, plural, one {# meddelande} other {# meddelanden}}."
}
